import { all, call, put, takeLatest } from 'redux-saga/effects';
import { noop } from 'lodash';
import * as contactsApi from '../api/Contacts';
import * as contactsActions from '../actions/Contacts';
import * as students from '../actions/Students';
import {
  CREATE_PUPIL_CONTACTS,
  DELETE_PUPIL_CONTACT,
  GET_EMERGENCY_CONTACTS,
  LINK_PUPIL_CONTACT,
  UPDATE_PUPIL_CONTACT,
} from '../constants/ActionTypes';
import { showErrorNotification } from '../actions';

function* getEmergencyContacts() {
  yield put(contactsActions.setContactsLoading(true));

  try {
    const { data } = yield call(contactsApi.getEmergencyContacts);

    yield put(contactsActions.getEmergencyContactsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }

  yield put(contactsActions.setContactsLoading(false));
}

function* updatePupilContact({ payload }) {
  const { contact, pupilId, setLoading = noop, meta = noop } = payload;
  try {
    yield call(setLoading, true);

    yield call(contactsApi.updatePupilContact, contact);
    yield put(students.getStudentRelatives(pupilId));

    yield call(meta);
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  } finally {
    yield call(setLoading, false);
  }
}

function* linkPupilContacts({ payload }) {
  try {
    yield call(contactsApi.linkPupilContact, payload);
    yield put(students.getStudentRelatives(payload.pupilId));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

function* createPupilContacts({ payload }) {
  const { pupilId, contact, setLoading = noop, meta = noop } = payload;
  try {
    yield call(setLoading, true);
    yield call(contactsApi.createPupilContact, contact);

    yield put(students.getStudentRelatives(pupilId));

    yield call(meta);
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  } finally {
    yield call(setLoading, false);
  }
}

function* deletePupilContact({ payload }) {
  try {
    yield call(contactsApi.deletePupilContact, payload);
    yield put(students.getStudentRelatives(payload.pupilId));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(GET_EMERGENCY_CONTACTS, getEmergencyContacts)]);
  yield all([takeLatest(UPDATE_PUPIL_CONTACT, updatePupilContact)]);
  yield all([takeLatest(CREATE_PUPIL_CONTACTS, createPupilContacts)]);
  yield all([takeLatest(LINK_PUPIL_CONTACT, linkPupilContacts)]);
  yield all([takeLatest(DELETE_PUPIL_CONTACT, deletePupilContact)]);
}
